<template>

  <div id="capture-image-preview-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-lg">
      <div class="modal-content">
        <div class="modal-header flex items-center justify-end">
            <a data-dismiss="modal" href="javascript:;">
              <XIcon class="w-8 h-8 text-gray-500" />
            </a>
          </div>
        <div class="modal-body p-5">
          <img :src="page_data.preview_url" alt="Preview Image" class="w-full" style="height: 80vh" />
          <!-- <image :src="page_data.preview_url" alt="Preview Image" class="w-full h-auto" /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>

import cash from 'cash-dom';
import { reactive } from 'vue';

const page_data = reactive({
  preview_url: ""
})

const showPreview = (preview_url) => {
  page_data.preview_url = preview_url;

  console.log(page_data.preview_url);
  cash('#capture-image-preview-modal').modal('show');
}

defineExpose({
  showPreview
});

</script>
